module.exports = __webpack_public_path__ + "9dee58c7a59ed69a469e34fe8e8d7462.woff";